<template>
  <el-form-item :label="label">
    <el-upload
      class="upload-demo"
      ref="upload"
      action="https://jsonplaceholder.typicode.com/posts/"
      :auto-upload="false"
      :disabled="preview"
    >
      <el-button slot="trigger" size="small" plain>Select file</el-button>
    </el-upload>
  </el-form-item>
</template>

<script>
export default {
  name: "File",
  props: {
    label: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    formIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      input: ""
    };
  },
  inject: ['preview'],

  computed: {
    setValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("update:value", value);
      }
    },
    preview() {
      return this.preview
    }
  },
  watch: {
    input() {
      this.setValue = this.input;
    }
  }
};
</script>

<style lang="scss" scoped></style>
